import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 維修品項 Detail。
 * GET `/aftersales/repair-item/{id}`
 *
 * @param {string} id
 */
export async function fetchRepairItemDetail(id) {
  const { data: raw } = await request.get(`/aftersales/repair-item/${id}`);
  return parseVer4DetailResponse(raw);
}
